import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';

@Component({
    selector: 'app-forgot-customer',
    templateUrl: './forgot-customer.component.html',
    styleUrls: ['./forgot-customer.component.scss'],
    standalone: false
})
export class ForgotCustomerComponent implements OnInit {
  forgotPassword!: UntypedFormGroup;
  sideImage:any;
  userType: any = localStorage.getItem('userType');

  constructor(private fb: UntypedFormBuilder, public commonService: CommonService, private router: Router) { }

  ngOnInit(): void {
    this.forgot();
  }

  forgot() {
    this.forgotPassword = this.fb.group({
      'email': new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/i)
      ]),
    })
  }



  add() {
    var data = {
      email: this.forgotPassword.value.email,
      userType: this.userType
    }
    localStorage.setItem('email', data['email'])
    this.commonService.showSpinner()
    this.commonService.postApi('user/forgotPassword', data, 0).subscribe((res: any) => {
      
      this.commonService.hideSpinner()
      if (res['responseCode'] == 200) {
        localStorage.setItem('email', this.forgotPassword.value.email)
        this.commonService.hideSpinner()
        this.commonService.successToast(res['responseMessage'])
        // set current url to localstorage 
        this.router.navigate(['/reset-otp-customer'],{queryParams : {email:this.forgotPassword.value.email}});
      }else{
        this.commonService.hideSpinner()
      this.commonService.errorToast(res['responseMessage'])
      }
    }, err => {
      if(err['responseCode'] == 404){
        this.commonService.hideSpinner()
        this.commonService.errorToast(err['responseMessage'])
      }
    else{
      this.commonService.hideSpinner()
      this.commonService.errorToast(err['responseMessage'])
    }
    })
  }

  preventSpace(event: any) {
    if ((event.charCode == 32 || event.charCode == 64) && !event.target.value) {
      event.preventDefault();
    }
  }

}
